import React, { Fragment, useState } from 'react';
import { useParams } from 'react-router-dom';

/*
  React Router keeps a detail page mounted when only its :id changes. Stepping to another record (previous / next
  arrows, links between records) mounts the page fresh so nothing of the previous record lingers in its state or in
  its child components; saving a new record (/new -> /<id>) keeps the page as it is.
*/
export default function RecordRoute({ children }) {
  const { id } = useParams();
  const [record, setRecord] = useState({ id, key: id });
  if (record.id !== id) setRecord({ id, key: record.id === 'new' ? record.key : id });
  return <Fragment key={record.key}>{children}</Fragment>;
}
